import PageHeader from "../components/PageHeader";
import HireBackendDeveloperContent from "../components/Hire-Backend-Developer-Content";

const HireBackendDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="Backend Developer" breadcrumbMenu="Home" breadcrumbMenuActive="Backend Developer" image="/images/backend-development.jpg" />
            <HireBackendDeveloperContent />
        </>
    )
}

export default HireBackendDevelopers;